import React, { useState, useEffect } from "react";

const CountdownTimer = ({SendOtpCode, noHp}) => {
    const [seconds, setSeconds] = useState(5 * 60);
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (seconds > 0) {
                // Kurangi waktu setiap detik
                setSeconds((prevSeconds) => prevSeconds - 1);
            } else {
                // Setelah 5 menit habis, tandai sebagai kadaluarsa
                setIsExpired(true);
                clearInterval(intervalId); // Hentikan interval
            }
        }, 1000);

        // Bersihkan interval setelah komponen tidak lagi digunakan
        return () => clearInterval(intervalId);
    }, [seconds]);

    // Konversi waktu tersisa menjadi menit dan detik
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    // Tampilkan countdown atau tombol resend
    return (
        <>
            {isExpired ? (
                <button
                    className="border-b-2 border-black_m-300"
                    onClick={() => {
                        setSeconds(5 * 60); // Mulai countdown lagi ketika tombol resend ditekan
                        setIsExpired(false); // Reset status expired
                        SendOtpCode(noHp); // Send again code otp
                    }}
                >
                    Kirim Ulang
                </button>
            ) : (
                <p className="font-medium">
                    <span className="text-[11px] text-justify text-black_m-300">
                        Masukan kode OTP sebelum
                    </span>{" "}
                    {`${minutes}:${
                        remainingSeconds < 10 ? "0" : ""
                    }${remainingSeconds}`}
                </p>
            )}
        </>
    );
};

export default CountdownTimer;
